import React from 'react'
import cn from 'classnames'

import { Box } from '@features/story/components/Box'
import { TiptapViewer } from '@components/TiptapViewer'
import { IntroductionProps } from './interface'

export function Introduction({
  intro,
  isIntroExist,
  className,
}: IntroductionProps) {
  return isIntroExist ? (
    <Box
      className={cn(
        'card p-[30px] mobile:p-[20px] mobile:pb-0 dark:border-purple',
        className
      )}
    >
      <Box.Title className='dark:text-dark-10 text-2xl mb-[20px] mobile:mb-[10px]'>
        แนะนำเรื่อง
      </Box.Title>
      <TiptapViewer className='story-reader' value={intro} />
    </Box>
  ) : null
}
